import { useRouter } from "next/router";
import * as React from "react";

import { useLeadFormModuleContext } from "@brexhq/next/src/components/modules/LeadForm/LeadFormModuleProvider";
import { useBypassSuccess } from "@brexhq/next/src/components/modules/LeadForm/utils";
import useSiteContext from "@brexhq/next/src/hooks/useSiteContext";

import { BlockRows } from "../../../../shared/BlockRows/BlockRows";

export const GTMInlineEmailSuccess = () => {
  const { bypassSuccessContentUrl, leadFormSuccess, theme } =
    useLeadFormModuleContext();
  const { navigators } = useSiteContext();
  const router = useRouter();
  const bypassSuccess = useBypassSuccess();
  const renderCustomSuccess = leadFormSuccess?.textRows?.length;

  const { shouldBypass, link, isInternalLink } = bypassSuccess(
    bypassSuccessContentUrl,
  );
  React.useEffect(() => {
    if (renderCustomSuccess) {
      return;
    }
    const rerouteIfBypass = () => {
      return isInternalLink ? router.push(link) : (window.location.href = link);
    };
    if (shouldBypass) {
      rerouteIfBypass();
    }
  }, [
    bypassSuccessContentUrl,
    isInternalLink,
    link,
    navigators,
    router,
    shouldBypass,
    renderCustomSuccess,
  ]);

  return renderCustomSuccess ? (
    <BlockRows
      rows={leadFormSuccess?.textRows}
      theme={theme}
      alignment="left"
    />
  ) : null;
};
